/*
 * Kivora Home — product-page sections (kv-pdp-*). Buttons rendered by snippets/kv-pdp-buy.liquid.
 * [data-kv-buy="scroll"]  smooth-scroll to the buy box and focus Add to cart.
 * [data-kv-buy="add"]     add the variant picked in the buy box to the cart, then stay / cart / checkout.
 */
(function () {
  if (window.__kvPdpInit) return;
  window.__kvPdpInit = true;

  function root() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function productForm() {
    // Skip Dawn's hidden Shop Pay installments form, which also posts to /cart/add.
    return (
      document.querySelector('product-info product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"][id^="product-form"]:not([id*="installment"])')
    );
  }

  function scrollToBuyBox(btn) {
    var form = productForm();
    var target = (form && (form.closest('.product__info-container') || form)) || document.getElementById('MainContent');
    if (!target) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
    var atc = form && form.querySelector('[type="submit"]');
    if (atc) {
      setTimeout(function () {
        atc.focus({ preventScroll: true });
      }, reduce ? 0 : 450);
    }
  }

  function addToCart(btn) {
    var id = btn.getAttribute('data-variant');
    var form = productForm();
    var picked = form && form.querySelector('[name="id"]');
    if (picked && picked.value) id = picked.value;
    if (!id || btn.getAttribute('aria-busy') === 'true') return;

    var label = btn.innerHTML;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding…';

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw r;
        return r.json();
      })
      .then(function () {
        var after = btn.getAttribute('data-after');
        if (after === 'checkout') {
          window.location.href = root() + 'checkout';
          return;
        }
        if (after === 'cart') {
          window.location.href = root() + 'cart';
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        btn.textContent = 'Added ✓';
        setTimeout(function () {
          btn.innerHTML = label;
          btn.removeAttribute('aria-busy');
        }, 1600);
      })
      .catch(function () {
        btn.innerHTML = label;
        btn.removeAttribute('aria-busy');
        alert('Sorry, this item could not be added to the cart.');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kv-buy]');
    if (!btn) return;
    var action = btn.getAttribute('data-kv-buy');
    if (action === 'scroll') {
      if (!productForm()) return;
      e.preventDefault();
      scrollToBuyBox(btn);
    } else if (action === 'add') {
      e.preventDefault();
      addToCart(btn);
    }
  });
})();
